import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BLACK, BG_GRAY, TEXT_GRAY } from '../../../styles/variables.style';

export const ProfileSectionWrapper = styled.div`
  margin-bottom: 80px;
`;

export const TitleWrapper = styled.div`
  color: ${TEXT_GRAY.COMMON_5};
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 3em;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin: 0 0 7em;
  `};
`;

export const Profile = styled.div`
  padding: 0 20px;
  ${media.tabletL`
    display: flex;
    padding: 0;
  `};
`;
export const ProfileImage = styled.div`
  img {
    width: 100%;
  }
  margin-bottom: 20px;
  ${media.tabletL`
    flex: 1;
    padding-right: 60px;
    margin-bottom: 0;
  `};
`;
export const ProfileContent = styled.div`
  color: ${BLACK};
  ${media.tabletL`
    flex: 1;
    padding-left: 60px;
  `};
`;
export const ProfileTitle = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
`;
export const ProfileNameEn = styled.div`
  font-size: 14px;
  font-weight: bold;
`;
export const ProfileName = styled.div`
  font-size: 30px;
  margin-bottom: 5px;
`;

export const ProfileDescription = styled.p`
  color: ${BLACK};
  margin: 0 0 0 0;

  ${media.tabletL`
    width: 80%;
  `};

  h1,
  h2,
  h3,
  p {
    &:first-child {
      margin-top: 0;
    }
  }
  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 22px;
  }
  h3 {
    font-size: 20px;
  }
  p {
    font-size: 14px;
    margin-bottom: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/RangePage/ProfileSection/ProfileSection.style.js